import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const deliveryAgentsApi = {
  getDeliveryAgents: async (filters: any = {}) => {
    const { search, isActive, page = 1, limit = 20 } = filters;
    let url = `${API_URL}/api/admin/delivery-agents?page=${page}&limit=${limit}`;

    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (isActive !== undefined) {
      url += `&isActive=${isActive}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getDeliveryAgentDetails: async (deliveryAgentId: string) => {
    const response = await axios.get(
      `${API_URL}/api/admin/delivery-agents/${deliveryAgentId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
    });

    return response.data;
  },

  updateDeliveryAgentStatus: async (deliveryAgentId: string, isActive: boolean) => {
    const response = await axios.put(
      `${API_URL}/api/admin/delivery-agents/${deliveryAgentId}/status`,
      { isActive },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  createDeliveryAgent: async (deliveryAgent: any) => {
    const response = await axios.post(
      `${API_URL}/api/admin/delivery-agents`,
      deliveryAgent,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  updateDeliveryAgent: async (deliveryAgentId: string, deliveryAgent: any) => {
    const response = await axios.put(
      `${API_URL}/api/admin/delivery-agents/${deliveryAgentId}`,
      deliveryAgent,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  getPendingRiders: async () => {
    const response = await axios.get(
      `${API_URL}/api/admin/delivery-agents/pending`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },
  
  approveOrRejectRider: async (deliveryAgentId: string, approvalStatus: "approved" | "rejected" | "inactive") => {
    const response = await axios.put(
      `${API_URL}/api/admin/delivery-agents/${deliveryAgentId}/approval`,
      { approvalStatus },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  getLiveRiders: async () => {
    const response = await axios.get(
      `${API_URL}/api/admin/riders/live`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },

  scheduleRiderStartTime: async (deliveryAgentId: string, scheduleData: any) => {
    const response = await axios.put(
      `${API_URL}/api/admin/delivery-agents/${deliveryAgentId}/schedule-start-time`,
      scheduleData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );
    return response.data;
  },
};

export default deliveryAgentsApi;
